/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

export const UrbitIcon = () => {
  return (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.49999 14.9643C11.3463 14.9643 14.4643 11.8463 14.4643 7.99999C14.4643 4.15372 11.3463 1.03571 7.49999 1.03571C3.65372 1.03571 0.535706 4.15372 0.535706 7.99999C0.535706 11.8463 3.65372 14.9643 7.49999 14.9643Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 1.57143C3.9496 1.57143 1.07143 4.4496 1.07143 8C1.07143 11.5504 3.9496 14.4286 7.5 14.4286C11.0504 14.4286 13.9286 11.5504 13.9286 8C13.9286 4.4496 11.0504 1.57143 7.5 1.57143ZM0 8C0 3.85786 3.35786 0.5 7.5 0.5C11.6421 0.5 15 3.85786 15 8C15 12.1421 11.6421 15.5 7.5 15.5C3.35786 15.5 0 12.1421 0 8Z"
        fill="black"
      />
      <path
        d="M10.7143 6.95473H9.44497C9.3494 7.51659 9.10372 7.85629 8.66695 7.85629C7.87533 7.85629 7.42495 6.92859 6.19656 6.92859C5.0091 6.92859 4.38124 7.66032 4.28572 9.05837H5.55504C5.65061 8.48345 5.89629 8.14375 6.34667 8.14375C7.13829 8.14375 7.5614 9.07145 8.81711 9.07145C9.97726 9.07145 10.6188 8.33971 10.7143 6.95473Z"
        fill="black"
      />
    </svg>
  );
};

export const EmailIcon = () => {
  return (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 11H1V2.5V1H13V2.5V11Z" fill="white" />
      <path d="M13 2.5V11H1V2.5M13 2.5V1H1V2.5M13 2.5L7 7L1 2.5" stroke="black" strokeWidth="1.2" />
    </svg>
  );
};
